<script setup lang="ts">
const props = defineProps<{
  blogUrl: string
  blogTitle: string
}>()

const facebookShare = computed(() => `https://www.facebook.com/sharer/sharer.php?u=${props.blogUrl}`)
const linkedinShare = computed(
  () => `https://www.linkedin.com/sharing/share-offsite/?url=${props.blogUrl}`
)
const twitterShare = computed(() => `https://twitter.com/intent/tweet?url=${props.blogUrl}&text=${encodeURIComponent(props.blogTitle)}`)
</script>

<template>
  <div class="share-buttons">
    <div class="flex gap-3 mt-6">
      <!-- Facebook -->
      <a
        :href="facebookShare"
        target="_blank"
        rel="noopener noreferrer"
        class="inline-flex h-10 w-10 items-center justify-center border border-black text-black hover:bg-black hover:text-neon-yellow transition-colors"
        aria-label="Share on Facebook"
      >
        <svg class="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M22.675 0h-21.35C.595 0 0 .593 0 1.326v21.348C0 23.406.595 24 1.326 24H12.82v-9.294H9.692V11.06h3.127V8.413c0-3.1 1.894-4.788 4.66-4.788 1.325 0 2.464.099 2.796.143v3.24l-1.918.001c-1.504 0-1.796.715-1.796 1.763v2.312h3.59l-.467 3.647h-3.123V24h6.116C23.406 24 24 23.406 24 22.674V1.326C24 .593 23.406 0 22.675 0z"/>
        </svg>
      </a>

      <!-- LinkedIn -->
      <a
        :href="linkedinShare"
        target="_blank"
        rel="noopener noreferrer"
        class="inline-flex h-10 w-10 items-center justify-center border border-black text-black hover:bg-black hover:text-neon-yellow transition-colors"
        aria-label="Share on LinkedIn"
      >
        <!-- LinkedIn icon -->
        <svg class="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M4.98 3.5C4.98 4.88 3.86 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM.5 8h4V24h-4V8zm7.5 0h3.8v2.2h.05c.53-1 1.84-2.2 3.8-2.2 4.06 0 4.81 2.67 4.81 6.15V24h-4v-7.1c0-1.69-.03-3.86-2.35-3.86-2.35 0-2.71 1.83-2.71 3.73V24h-4V8z"/>
        </svg>
      </a>

      <!-- Twitter -->
      <a
        :href="twitterShare"
        target="_blank"
        rel="noopener noreferrer"
        class="inline-flex h-10 w-10 items-center justify-center border border-black text-black hover:bg-black hover:text-neon-yellow transition-colors"
        aria-label="Share on Twitter"
      >
        <!-- Twitter/X icon -->
        <svg class="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
        </svg>
      </a>
    </div>
  </div>
</template>

